import { render, staticRenderFns } from "./GameRecord.vue?vue&type=template&id=1dc09fba&scoped=true"
import script from "./GameRecord.vue?vue&type=script&lang=js"
export * from "./GameRecord.vue?vue&type=script&lang=js"
import style0 from "./GameRecord.vue?vue&type=style&index=0&id=1dc09fba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c18e9a749cc21ff970a79c65ca01237d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc09fba",
  null
  
)

export default component.exports